/* jshint browser: true */
define(['angular'], function(angular) {
    'use strict';

    angular.module('ecMultipleChart')
        .factory('exportCSV', ['CSV', '$document', '$timeout', exportCSV]);

    function exportCSV(CSV, $document, $timeout) {

        var createFile = function(result, charset, fileName) {

            if (!Blob) {
                throw (new Error('Blob is not supported by your browser'));
            }

            result = '\ufeff' + result;

            var blob = new Blob([result], {
                type: 'text/csv;charset=' + charset + ';'
            });

            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                var downloadContainer = angular.element('<div data-tap-disabled="true"><a></a></div>'),
                    downloadLink = angular.element(downloadContainer.children()[0]);
                downloadLink.attr('href', window.URL.createObjectURL(blob));
                downloadLink.attr('download', fileName);
                downloadLink.attr('target', '_blank');

                $document.find('body').append(downloadContainer);
                $timeout(function() {
                    downloadLink.get(0).click();
                    downloadLink.remove();
                }, 0);
            }
        };

        var exportData = function(dataObject, optionsObject) {
            var options = optionsObject || {};

            options.header = options.header || null;
            options.decimalSep = options.decimalSep || '.';
            options.label = options.keysToHeaders || false;
            options.columnOrder = options.columnOrder || null;
            options.fileName = options.fileName || 'download.csv';
            options.charset = options.charset || 'utf-8';
            options.txtDelim = options.txtDelim || '"';

            if (dataObject) {
                CSV.stringify(dataObject, options).then(function(result) {
                    createFile(result, options.charset, options.fileName);
                });
            } else {
                throw (new Error('Data to export is missing'));
            }
        };

        return {
            exportData: exportData
        };
    }
});



// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/export-service.js